import React, { useEffect, useState } from 'react'

//style
import styles from './ChangeLanguage.module.css';

import Globe from '../../../assets/svg/Globe';
import { useTranslation } from 'react-i18next';


const ChangeLanguage = (props) => {
  //changing language
  const { i18n } = useTranslation();

  //all languages that user can choose
  const languages = ['ENG', 'РУС', 'ҚАЗ'];

  //current language
  const [language, setLanguage] = useState("ENG");

  //to open dropdown
  const [open, setOpen] = useState(false);

  //changing language
  const onChangeLanguage = (lang) => {
    setLanguage(lang);

    //changing language via i18n;
    const langs = { "ENG": "en", "РУС": "ru", "ҚАЗ": "kz" };
    i18n.changeLanguage(langs[lang]);
  }

  //getting language on mount
  useEffect(() => {
    const langs = { "en": "ENG", "ru": "РУС", "kz": "ҚАЗ" };
    setLanguage(langs[i18n.resolvedLanguage]);
  }, [])

  return (
    <div className={styles.container} onClick={() => setOpen((o) => !o)} style={{ color: props.isNavSticky ? "black" : "white" }}>
      <Globe height={24} width={24} fill={props.isNavSticky ? "black" : "white"} />
      <div className={styles.dropdown} onMouseLeave={() => setOpen(false)}>
        <p className={styles.text}>{language}</p>
        {open &&
          <ul className={styles.dropdownList}>
            {
              languages.map((element, index) => {
                if (language === element) {
                  return;
                }
                return <button key={index} className={styles.dropdownItem} onClick={() => onChangeLanguage(element)} >{element}</button>;
              })
            }
          </ul>
        }
      </div>
    </div>
  );
}
export default ChangeLanguage;